

<template>
  <div class="relative lg:sticky top-0 z-50">


    <header id="app_nav" class=" border-b border-gray-200 z-40  top-0 w-full">
      <!-- start top nav -->
      <Disclosure as="nav" class="bg-primary block" v-slot="{ open }">
        <div class=" overflow-x-clip sm:px-6 lg:px-28 px-4">
          <div class="flex  items-center justify-between h-20">
            <!-- start left side of nav -->
            <div
              class=" flex w-auto lg:w-5/12 md:min-w-[30.666667%]  items-center  justify-start  lg:space-s-12 transition-all ease-in-out duration-200"
              :class="{ '!opacity-0 !w-[0%] !min-w-[0%]': !isSearchCollapsed }">
              <!-- Language -->
              <a role="button" @click="changeLanguage()" class="!text-decoration[none]	hidden lg:inline-block w-[58px] cursor-pointer ">
                <div class="flex items-center text-sm">
                  <img src="../../assets/icons/ic-language.svg" class="block w-6 h-6  me-1" />
                      <span v-if="appLanguage == 'en'">عربي</span>
                      <span v-else>En</span>
                </div>
              </a>

              <!-- location -->
              <a role="button" class="!text-decoration[none] !me-2 lg:max-w-[180px]" @click="openPickAreaModal">
                <div class="flex items-center space-s-2">
                  <img src="../../assets/icons/ic-location.svg" class="block w-6 h-6" />
                  <span class=" line-clamp-1 text-sm break-all">{{ selectedArea?.name ? selectedArea?.name : t('general.Choose_Location') }}</span>
                  <font-awesome-icon icon="chevron-down" class="text-sm " />
                </div>
              </a>
            </div>
            <!-- End left side of nav -->

            <!-- Start Search -->
            <Transition >
              <div class="flex h-14 transition-all ease-in-out duration-600"
                :class="{ 
                  '!z-50 !w-screen': !isSearchCollapsed ,
                  '!m-auto w-[43%] !justify-center': !isShowMobileInputSearch ,
                  '!w-[0%]': isShowMobileInputSearch ,
                  'hidden md:flex': isSearchCollapsed
                  }">
                <expanded-search-input class=" w-full " :isSearchCollapsed="isSearchCollapsed"
                  @onExpandSearchInput="onExpandSearchInput" 
                  @collapseSearchInput="collapseSearchInput"/>
              </div>
            </Transition>
            <!-- End Search -->

          <!-- start right side of nav -->

            <!-- In case of logged in -->
            <div v-if="isLoggedIn"
              class=" md:flex w-auto md:w-3/12 flex    items-center md:ms-16 justify-between space-s-2  transition-all ease-in-out duration-300"
              :class="{ '!opacity-0 !w-[0%] !m-0 !p-0': !isSearchCollapsed }">
             
              <!-- show search bar button in mobile -->
              <button
              id="searchBtn-mobile" 
              class="hidden items-center " 
              :class="{
                '!flex':!isShowMobileInputSearch,
                '!w-[0%] !hidden': !isSearchCollapsed}"
              @click="expandSearchInput()">
                <img src="../../assets/icons/ic-search.svg" alt="search" class="img-fluid md:hidden flex rtl-icon min-w-[24px] h-6" />
              </button>

              <!-- Track Order -->
              <router-link as="a" to="/setting/track-order"
              :class="{'hidden': !isSearchCollapsed}">
                <div class=" items-center hover:underline hidden md:flex">
                  <img src="../../assets/icons/ic-track-order.svg" class="min-w-[24px] h-6  me-2" />
                  <span>{{ t('buttons.Track_Order') }}</span>
                </div>
              </router-link>
        
              <!-- Profile dropdown -->
              <Menu as="div" class="ms-auto relative z-10"
              :class="{'!w-[0%]': !isSearchCollapsed}">
                <div>
                  <MenuButton class="max-w-xs  rounded-full flex items-center text-sm ">
                    <img src="../../assets/icons/ic-profile-circle.svg" class="min-w-[32px] h-8" />
                  </MenuButton>
                </div>
                <transition enter-active-class="transition-all ease-in-out duration-100"
                  enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100"
                  leave-to-class="transform opacity-0 scale-95">
                  <MenuItems
                    class="origin-top-right absolute end-0 mt-2 w-48 rounded-md shadow-lg  divide-y divide-gray-100 py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div class="px-1 py-1">
                      <MenuItem>
                      <p class="block px-4 py-2 text-sm text-dark-gray-3">
                        {{t('general.Hello')}} <span class="font-bold ">{{ userInfo?.name ? userInfo.name : '' }}</span>
                      </p>
                      </MenuItem>
                    </div>
                    <div class="px-1 py-1">
                      <MenuItem v-slot="{ active }">
                      <router-link to="/setting"
                        :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-dark-gray-3']">
                        <div class="flex justify-between items-center">
                          <span>{{t('general.Settings')}}</span>
                          <font-awesome-icon icon="chevron-right" class="h-3 w-3 text-dark-gray-10 text-base	 rtl-icon " />

                        </div>
                      </router-link>
                      </MenuItem>
                      <MenuItem v-slot="{ active }">
                      <router-link to="/wishlist"
                        :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-dark-gray-3']">
                        <div class="flex justify-between items-center">
                          <span>{{t('buttons.WishList')}}</span>
                          <font-awesome-icon icon="chevron-right" class="h-3 w-3 text-dark-gray-10 text-base	 rtl-icon " />
                        </div>
                      </router-link>
                      </MenuItem>
                    </div>
                    <div class="px-1 py-1">
                      <MenuItem>
                      <button @click="logOut()"
                        class="w-full px-4 py-2  text-red flex justify-start items-center text-sm">
                        {{t('buttons.Logout')}}
                      </button>
                      </MenuItem>
                    </div>
                  </MenuItems>
                </transition>
              </Menu>


            </div>
            <!-- In case of Not logged in -->
            <div v-else
              class="flex md:items-center w-4/12 md:ms-16 justify-between  h-full transition-all ease-in-out duration-200"
              :class="{ '!opacity-0 !w-[0%] !m-0 !p-0': !isSearchCollapsed }">
              
              <!-- start show search bar button in mobile -->
              <button 
              id="searchBtn-mobile" 
              class="hidden items-center" 
              :class="{'!flex':!isShowMobileInputSearch,
                '!w-[0%] !hidden': !isSearchCollapsed}"
              @click="expandSearchInput()">
                <img src="../../assets/icons/ic-search.svg" alt="search" class="img-fluid md:hidden flex min-w-[24px] h-6 me-2" />
              </button>

              <!-- Login button -->
              <a role="button" @click="openLoginModal" 
              class=" font-medium w-auto lg:w-full h-full flex items-center justify-around  px-8 me-2 "
              :class="{'!w-[0%] hidden': !isSearchCollapsed}">
                <span>{{ t('buttons.Login') }}</span>
              </a>

              <!-- Register button -->
              <a to="/" role="button" @click="openRegisterModal"
                class="bg-secondary rounded-lg text-white font-medium group w-full min-w-[170px]  hidden lg:flex items-center justify-around  px-8 py-4 "
                :class="{'!w-[0%] !hidden': !isSearchCollapsed}">
                <span class="rtl:group-hover:translate-x-1 ltr:group-hover:-translate-x-1 transition ease-in-out delay-150 duration-30 ">{{ t('buttons.Get_Started') }}</span>
                <font-awesome-icon icon="chevron-right"
                  class="text-sm rtl:group-hover:-translate-x-1 group-hover:translate-x-1 transition ease-in-out delay-150 duration-30 rtl-icon " />
              </a>
             
            </div>
            <!-- End right side of nav -->
          </div>
        </div>
      </Disclosure>
      <!-- End top nav -->

      <!-- Start Navigation bar large screens -->
      <nav aria-label="Top" class="navbar bg-white px-4	sm:px-6 lg:px-28 relative">
        <div class="">
          <div class="h-16 flex items-center">
            <!-- Start mobile navigation menu Button -->
            <button type="button" class="rounded-md me-4 lg:hidden" @click="open = true">
              <span class="sr-only">Open menu</span>
              <img src="../../assets/icons/ic-home-menu.svg" class=" h-4" />
            </button>
            <!-- end mobile navigation menu Button -->
            <!-- Logo -->
            <Transition>
              <div class=" flex logo lg:me-8">
                <router-link to="/">
                  <span class="sr-only">Rdna Logo</span>
                  <img class="h-8 min-w-[100px]  max-w-none md:inline-block hidden" src="../../assets/rdna-logo-mobile.svg"
                    alt="" />
                  <img class="h-8 min-w-[100px] max-w-none inline-block md:hidden" src="../../assets/rdna-logo-mobile.svg"
                    alt="" />

                </router-link>
              </div>
            </Transition>

            <!-- Start Categories menu -->
            <Transition>
              <PopoverGroup class="  hidden lg:inline-flex lg:self-stretch h-full">
                <div class=" h-full flex space-s-8">
                  <a v-if="navigation" :href="page.url" v-for="page in navigation?.pages" :key="page.id" 
                    class="flex items-center text-base font-medium text-gray-700 hover:text-gray-800">{{ page.title
                    }}</a>
                  <!-- skeleton -->
                  <div v-if="!navigation && isSkeletonLoading" v-for="(page, index) in navigationPagesPlaceHolder" :key="index" class=" flex flex-col justify-center items-center">
                    <p  class="shadow skeleton-box w-[91px] h-[15px]"></p>
                  </div>
                </div>
              </PopoverGroup>
            </Transition>
            <!-- End Categories menu -->

            <!-- Start Navbar Cart Menu and Notification -->
            <Transition>
              <div class=" flex items-center h-full ms-auto">
                  <!-- start notification button and menu -->
                  <div class="ml-4 flow-root lg:ml-6" v-if="isLoggedIn && !isCartLoadingOpen">
                        <div class="text-right">
                          <!-- start notification button and menu -->
                          <Menu as="div" class="relative hidden  md:block">
                            <div>
                              <MenuButton @click="reRenderNotificationComponent" class="group -m-2 p-2 flex items-center rounded-xl">
                                <img src="../../assets/icons/notification.svg" class="img-fluid" />
                                <span
                                  class=" w-5 px-1 absolute -top-1 -end-1 border-white border text-[9px] text-white bg-red rounded-full  h-5 flex items-center justify-center"
                                  :class="{ '!w-auto': unreadNotificationsCounter > 99 }">
                                  {{ unreadNotificationsCounter ? unreadNotificationsCounter : 0 }}
                                </span>
                              </MenuButton>
                            </div>
                      
                            <notification-menu  v-if="showNotificationsMenu"/>
                          </Menu>
                          <!-- End Nav bar Menus Buttons in Mobile -->
      
                          <!-- Start Nav bar Menus Buttons in Mobile -->
                          <Menu as="div" class="relative md:hidden block">
                            <div>
                              <MenuButton @click="notificationMenuButtonCheck" class="group -m-2 p-2 flex items-center rounded-xl">
                                <img src="../../assets/icons/notification.svg" class="img-fluid" />
                                <span
                                  class=" w-5 px-1 absolute -top-1 -end-1 border-white border text-[9px] text-white bg-red rounded-full  h-5 flex items-center justify-center"
                                  :class="{ '!w-auto': unreadNotificationsCounter > 99 }">
                                  {{ unreadNotificationsCounter ? unreadNotificationsCounter : 0 }}
                                </span>
                              </MenuButton>
                            </div>
                          </Menu>
      
                          <!-- End notification Buttons in Mobile -->
      
                        </div>
                  </div>
                  <div v-if="isCartLoadingOpen" class="ms-4 flow-root lg:ms-6 !rounded-xl shadow skeleton-box w-8 h-8"></div>

                  <!-- end notification button and menu -->
  
                  <!-- Start Cart Button and menu-->
                  <div class="ms-4 flow-root lg:ms-6" v-show="isHideCart && cartProducts && !isCartLoadingOpen">
  
                    <div class=" text-end">
                      <!-- Start Nav bar Menus Buttons in Tablet and Large -->
                      <Menu as="div" class="relative hidden  md:block ">
                        <div>
                          <MenuButton @click="reRenderCartComponent()"
                            class="group -m-2 p-2 hidden md:flex items-center  bg-[#EEEEEE] rounded-xl">
                            <img src="../../assets/icons/ic-cart.svg" class="img-fluid " />
                            <span
                              class="absolute -top-1 -end-1 border-white border text-[9px] text-white bg-red rounded-full w-5 h-5 flex items-center justify-center">
                              {{ cartProducts?.length ? cartProducts?.length : 0 }}
                            </span>
                            <span class="sr-only">items in cart, view bag</span>
                          </MenuButton>
                        </div>
  
                        <!-- start Cart Menu Component -->
                        <div class="hidden md:block">
                          <cart-menu @isCartLoading="isCartLoading"/>
                        </div>
                        <!-- End Cart Menu Component -->
  
                      </Menu>
                      <!-- End Nav bar Menus Buttons in Tablet and Large -->
  
                      <!-- Start Nav bar Menus Buttons in Mobile -->
                      <Menu as="div" class="relative  block md:hidden">
                        <div>
                          <MenuButton @click="cartMenuButtonCheck"
                            class="group -m-2 p-2 flex items-center  bg-[#EEEEEE] rounded-xl">
                            <img src="../../assets/icons/ic-cart.svg" class="img-fluid " />
                            <span
                              class="absolute -top-1 -end-1 border-white border text-[9px] text-white bg-red rounded-full w-5 h-5 flex items-center justify-center">
                              {{ cartProducts?.length ? cartProducts?.length : 0 }}
                            </span>
                            <span class="sr-only">items in cart, view bag</span>
                          </MenuButton>
                        </div>
                      </Menu>
                      <!-- End Nav bar Menus Buttons in Mobile -->
                    </div>
                  </div>
                  <div v-if="!isHideCart && !cartProducts || isCartLoadingOpen" class="ms-4 flow-root lg:ms-6 !rounded-xl shadow skeleton-box w-8 h-8"></div>
                  <!-- End Cart Button and menu-->
                </div>
            </Transition>
          </div>
        </div>
      </nav>
      <!-- End Navigation bar-->

      <!-- Start Mobile sidebar menu -->
      <TransitionRoot as="template" :show="open">
        <Dialog as="div" class="relative z-100 lg:hidden" @close="open = false">
          <TransitionChild as="template" enter="transition-opacity ease-linear duration-300" enter-from="opacity-0"
            enter-to="opacity-100" leave="transition-opacity ease-linear duration-300" leave-from="opacity-100"
            leave-to="opacity-0">
            <div class="fixed inset-0 bg-white/50" />
          </TransitionChild>
          <div class="fixed inset-0 flex z-40">
            <TransitionChild as="template" enter="transition ease-in-out duration-300 transform"
              enter-from="rtl:translate-x-full -translate-x-full" enter-to="translate-x-0"
              leave="transition ease-in-out duration-300 transform" leave-from="translate-x-0"
              leave-to="rtl:translate-x-full -translate-x-full">
              <DialogPanel
                class="relative max-w-xs w-full bg-white drop-shadow-lg  pb-12 flex flex-col overflow-y-auto">
                <div class="px-4 pt-5 pb-2 flex justify-between items-center">
                  <button type="button" class="-m-2 p-2 rounded-md inline-flex items-center justify-center text-dark-2"
                    @click="open = false">
                    <span class="sr-only">Close menu</span>
                    <XIcon class="h-6 w-6" aria-hidden="true" />
                  </button>
                  <!-- Language -->
                  <a role="button" @click="changeLanguage()" class="!text-decoration[none] cursor-pointer	">
                    <div class="flex items-center">
                      <img src="../../assets/icons/ic-language.svg" class="block w-6 h-6  me-1" />
                      
                      <span v-if="appLanguage == 'en'">عربي</span>
                      <span v-else>En</span>

                    </div>
                  </a>
                </div>

                <!-- logo -->
                <div class="py-6 px-4 space-y-6 flex justify-start">
                  <img class="h-4 w-auto max-w-none  md:hidden" src="../../assets/rdna-logo-mobile.svg" alt="" />
                </div>

                <!-- Links -->
                <div class=" py-6 px-4 space-y-6">
                  <div v-if="navigation" v-for="page in navigation?.pages" :key="page.id" class="flow-root">
                    <a :href="page.url" class="-m-2 p-2 block text-dark-2 text-base">{{ page.title
                    }}</a>
                  </div>
                  <!-- skeleton -->
                  <div v-if="!navigation && isSkeletonLoading" v-for="(page, index) in navigationPagesPlaceHolder" :key="index" class="flow-root">
                    <p  class=" mb-0 -m-2 p-2 block text-dark-2 text-base shadow skeleton-box w-[91px] h-[15px]"></p>
                  </div>

                  <div class="md:hidden flex justify-start items-center text-base">
                    <router-link as="a" to="/setting/track-order" class="-m-2 p-2 block text-dark-2 text-base">
                      <div class=" items-center hover:underline flex ">
                        <!-- <img src="../../assets/icons/ic-track-order.svg" class="min-w-[24px] h-6  me-2" /> -->
                        <span>{{ t('buttons.Track_Order') }}</span>
                      </div>
                    </router-link>
                  </div>
                  <!-- notifications -->
                  <!-- <div class="flex justify-start items-center text-base">
                    <a href="/notifications" class="-m-2 p-2 me-3 block text-dark-2 text-base">Notification center</a>
                    <span
                      class=" border-white border text-[9px] text-white bg-red rounded-full w-5 h-5 flex items-center justify-center">
                      2
                    </span>
                  </div> -->
                

                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </Dialog>
      </TransitionRoot>
      <!-- End Mobile sidebar menu -->
    </header>

    <!-- Start select Area Modal -->
    <TransitionRoot appear :show="isPickAreaModal || isNeedSelectArea" as="template">
      <pick-area-modal v-show="isPickAreaModal || isNeedSelectArea" @cancel="closeModals()" :areasList="areasList">
      </pick-area-modal>
    </TransitionRoot>
    <!-- end select Area Modal -->

    <!-- Start Login and Register Modals -->
    <TransitionRoot appear :show="isRegisterModal" as="template">
      <Register v-show="isRegisterModal && !isLoginModal" @openLoginModal="openLoginModal" @openOTPModal="openOTPModal"
        @openSendEmailModal="openSendEmailModal" @closeModals="closeModals" />
    </TransitionRoot>
    <TransitionRoot appear :show="isLoginModal" as="template">
      <Login v-show="isLoginModal && !isRegisterModal" @openRegisterModal="openRegisterModal"
        @openOTPModal="openOTPModal" 
        @openForgotPasswordModal="openForgotPasswordModal"
        @openSendEmailModal="openSendEmailModal" 
        @closeModals="closeModals" />
    </TransitionRoot>
    <!-- End Login and Register Modals -->

    <!-- Start OTP Modal -->
    <TransitionRoot appear :show="isOTPModal" as="template">
      <otp-modal v-show="isOTPModal" @cancel="closeModals()">
      </otp-modal>
    </TransitionRoot>
    <!-- End OTPModal -->

    <!-- Start email Sent  Modal -->
    <TransitionRoot appear :show="isEmailSendModal" as="template">
      <send-email-modal v-show="isEmailSendModal" @cancel="closeModals()">
      </send-email-modal>
    </TransitionRoot>
    <!-- End email Sent  Modal -->

    <!-- Start forgot password Modal -->
    <TransitionRoot appear :show="isForgotPasswordModal" as="template">
      <forgot-password-modal v-show="isForgotPasswordModal" 
      @openSendEmailModal="openSendEmailModal"
      @cancel="closeModals()"
      :forgetPasswordModalTitle="forgetPasswordModalTitle">
      </forgot-password-modal>
    </TransitionRoot>
    <!-- End forgot password Modal -->


    
  </div>

</template>

<script>
import { ref, onBeforeMount, watch, computed, nextTick } from 'vue';
import useEventsBus from '../../common/eventBus';

import { RouterLink, useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";

import Routes from "@/common/Routes"
import Request from "@/common/Request"
import Response from "@/common/Response"

import Login from "@/components/organisms/Login";
import Register from "@/components/organisms/Register";
import OtpModal from "@/components/organisms/OtpModal.vue";
import sendEmailModal from "@/components/organisms/responseModals/sendEmailModal.vue";
import PickAreaModal from "@/components/organisms/PickAreaModal";
import ForgotPasswordModal from "@/components/organisms/ForgotPasswordModal";
import ExpandedSearchInput from '@/components/organisms/ExpandedSearchInput'
import CartMenu from "@/components/organisms/CartMenu"
import NotificationMenu from "@/components/organisms/NotificationMenu";

import {
  Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems,
  Dialog,
  DialogPanel,
  Popover,
  PopoverButton,
  PopoverGroup,
  PopoverPanel,
  Tab,
  TabGroup,
  TabList,
  TabPanel,
  TabPanels,
  TransitionChild,
  TransitionRoot
} from '@headlessui/vue';
import { BellIcon, MenuIcon, XIcon, TranslateIcon, LocationMarkerIcon } from '@heroicons/vue/outline'
import store from "@/store";



export default {
  name: "app-nav",
  components: {
    Login,
    Register,
    OtpModal,
    sendEmailModal,
    PickAreaModal,
    ForgotPasswordModal,
    ExpandedSearchInput,
    CartMenu,
    NotificationMenu,
    Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems,
    Dialog,
    DialogPanel,
    Popover,
    PopoverButton,
    PopoverGroup,
    PopoverPanel,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
    TransitionChild,
    TransitionRoot,
    BellIcon, MenuIcon, XIcon, TranslateIcon, LocationMarkerIcon
  },

  setup() {
    const { t } = useI18n();
    const route = useRoute()
    const router = useRouter()
    const { bus } = useEventsBus()

    const isSkeletonLoading = ref(false)
    const isCartLoadingOpen = ref(false)
    
    const isLoggedIn = computed(() => { return store.getters.isLoggedIn })
    const userInfo = computed(() => { return store.getters.userInfo })
    const cartProducts = computed(() => { return store.getters.cartProducts || null })
    //expanded search input
    const isSearchCollapsed = ref(true)
    const isShowMobileInputSearch = ref(false)

    const collapseSearchInput = function () {
      if (document.getElementById('global-search') && document.getElementById('expanded-search') ) {
          document.getElementById('expanded-search').blur()
          isSearchCollapsed.value = true
          isShowMobileInputSearch.value = false
      }
    }
    
    const onExpandSearchInput = function () {
      isSearchCollapsed.value = false
    }

    const expandSearchInput = async function () {
      isShowMobileInputSearch.value = true
      await nextTick()
      isSearchCollapsed.value = false
      await nextTick()
      document.getElementById('expanded-search').focus()
    }

    const user = {
      name: 'Tom Cook',
      email: 'tom@example.com',
      imageUrl:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
    }
    const navigation = ref(null)
    const navigationPagesPlaceHolder = ref(['','','',''])


    // notifications 
    const unreadNotificationsCounter = computed(() => { return store.getters.unReadNotifications?.length })

    //Areas
    const areasList = ref([])
    const selectedArea = computed(() => { return store.getters.userArea })

    //language 
    const appLanguage = computed(() => { return store.getters.appLanguage })
    
    //logout 
    const logOut = function () {
      store.dispatch("logout", {})
    }

    //change language
    const changeLanguage = function() {
      if(appLanguage.value == 'en') {
        store.commit('setLanguage', 'ar')
      }else {
        store.commit('setLanguage', 'en')
      }
      location.reload()
    }

    //modal
    const open = ref(false)
    const isLoginModal = ref(false)
    const isRegisterModal = ref(false)
    const isOTPModal = ref(false)
    const isEmailSendModal = ref(false)
    const isPickAreaModal = ref(false)
    const isForgotPasswordModal = ref(false)
    
    const isNeedSelectArea = computed(() => { return store.getters.isNeedSelectArea })
    const showCartMenu = ref(true)
    const showNotificationsMenu = ref(true)
    
    const openRegisterModal = function () {
      setTimeout(() => {
        isLoginModal.value = false
      })
      // if(isLoginModal.value = false) {
      setTimeout(() => {
        isRegisterModal.value = true
      }, isLoginModal.value ? 350 : 0)
      // }

    }
    const openLoginModal = function () {

      setTimeout(() => {
        isRegisterModal.value = false
      })
      setTimeout(() => {
        isLoginModal.value = true
      }, isRegisterModal.value ? 350 : 0)
    }
    const openOTPModal = (async () => {
      setTimeout(() => {
        isLoginModal.value = false
        isRegisterModal.value = false
      })
      setTimeout(() => {
        isOTPModal.value = true
      }, 350)
    })
    
    async function verifyEmail() {
      await new Request().get('send/verify/email').then((res) => {
        if (res.status) {
          isEmailSendModal.value = true
        }
      })
    }

    const openSendEmailModal = function () {
      setTimeout(() => {
        isLoginModal.value = false
        isRegisterModal.value = false
      })
      setTimeout(() => {
        verifyEmail()
      }, 350)
    }
    const openPickAreaModal = function () {
      //get areas list
      if (areasList.value.length == 0) {
        new Request().get('areas').then((res) => {
          if (res?.data && res.data.data) {
            areasList.value = res.data.data
            isPickAreaModal.value = true
          }
        }).catch((err) => {
        })
      } else {
        isPickAreaModal.value = true
      }
    }
    const forgetPasswordModalTitle = ref('')
    const openForgotPasswordModal = function (modalTitle) {
     
      setTimeout(() => {
        forgetPasswordModalTitle.value = modalTitle
        isLoginModal.value = false
      })
      setTimeout(() => {
        isForgotPasswordModal.value = true
      }, 350)
    }

    const isHideCart = ref(null);
    // check if checkout or view cart page is active to hide cart icon
    watch(route, () => {
      isHideCart.value = !route.matched.some(({ name }) => name === ('view-cart' || 'checkout'))
    });

    //error 401 interceptor eventBus
    watch(()=>bus.value.get('showLogin'), (val) => {
      if(val) {
        openLoginModal()
      }
    })

    onBeforeMount(async() => {
      isSkeletonLoading.value = true
      //get nav bar list
			await new Request().get("menu/header").then((res) => {
        navigation.value = { pages: res?.data?.data }
        isSkeletonLoading.value = false
      })

      // hide cart menu button in case of open view-cart or checkout page
      isHideCart.value = !route.matched.some(({ name }) => name === ('view-cart' || 'checkout'))

    })
    return {
      t,
      isSkeletonLoading,
      isLoggedIn,
      userInfo,
      isHideCart,
      cartProducts,
      user,
      navigation,
      navigationPagesPlaceHolder,
      open,
      //cart loader emitted
      isCartLoadingOpen,
      isCartLoading(response) {
        isCartLoadingOpen.value = response? true : false
      },
      //expanded-search
      isSearchCollapsed,
      isShowMobileInputSearch,
      onExpandSearchInput,
      collapseSearchInput,
      expandSearchInput,
      //notifications
      unreadNotificationsCounter,
      //user area
      areasList,
      selectedArea,
      //logout
      logOut,
      //modal
      isRegisterModal,
      isLoginModal,
      isOTPModal,
      isEmailSendModal,
      isPickAreaModal,
      isForgotPasswordModal,
      isNeedSelectArea,
      showCartMenu,
      showNotificationsMenu,
      forgetPasswordModalTitle,
      openRegisterModal,
      openLoginModal,
      openOTPModal,
      openSendEmailModal,
      openPickAreaModal,
      openForgotPasswordModal,
      openModal() {
        isRegisterModal.value = false
        isLoginModal.value = true
      },
      closeModals() {
        isPickAreaModal.value = false
        store.commit('selectAreaModal', false)
        isOTPModal.value = false
        isEmailSendModal.value = false
        isRegisterModal.value = false
        isLoginModal.value = false
        isForgotPasswordModal.value = false
        
      },
      cartMenuButtonCheck(event) {
        event.preventDefault();
        router.replace(Routes.VIEW_CART)
      },
      notificationMenuButtonCheck(event) {
        event.preventDefault();
        router.replace(Routes.NOTIFICATIONS_PAGE)
      },
      reRenderNotificationComponent () {
        showNotificationsMenu.value = false
        setTimeout(() => {
          showNotificationsMenu.value = true
        }, 100);
      },
      reRenderCartComponent() {
        showCartMenu.value = false
        setTimeout(() => {
          showCartMenu.value = true
        }, 100);
      },
      //language,
      appLanguage,
      changeLanguage,
    }
  },
}




</script>

<style lang="scss">
header#app_nav .navbar {
  // backdrop-filter: blur(16px);
}


.v-enter-from,
.v-leave-to {
  opacity: 0;
  // width: 0px;
}
</style>


